import { AttributionMetricsDocument } from 'app/generated/gql/graphql'
import { gqlQuery } from 'app/lib/graphqlClient'
import type { DateRangeInput } from 'app/generated/graphql'

/** Use the same contact buckets as Attribution, without the selected channel or comparison range. */
export function createMarketingChannelFetcher(
  dateRange: DateRangeInput,
  locationIds: string[],
  integrationStatus: string,
) {
  return async ({ query = `` }: { query?: string }) => {
    if (!dateRange.fromDate || !dateRange.toDate) return { hits: [] }
    const result = await gqlQuery(AttributionMetricsDocument, {
      dateRange,
      groupBy: `channel`,
      locationIds: locationIds.length ? locationIds : undefined,
      integrationStatus: integrationStatus || undefined,
    })
    if (result.error) throw result.error
    const hits = [
      ...new Set(
        (result.data?.marketingMetrics.hits ?? [])
          // Spend and budget records can also create buckets, but they are not contacts.
          .filter((row) => row.leads > 0 && row.bucket && row.bucket.toLowerCase().includes(query.toLowerCase()))
          .map((row) => row.bucket),
      ),
    ].sort((a, b) => a.localeCompare(b))
    return { hits }
  }
}
